/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteTabDto
 */
export interface QuoteTabDto {
    /**
     * Quote ID
     * @type {string}
     * @memberof QuoteTabDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteTabDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteTabDto
     */
    borrowerName?: string;
    /**
     * 
     * @type {number}
     * @memberof QuoteTabDto
     */
    clientPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteTabDto
     */
    product?: number;
}

/**
 * Check if a given object implements the QuoteTabDto interface.
 */
export function instanceOfQuoteTabDto(value: object): value is QuoteTabDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function QuoteTabDtoFromJSON(json: any): QuoteTabDto {
    return QuoteTabDtoFromJSONTyped(json, false);
}

export function QuoteTabDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteTabDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'borrowerName': json['borrowerName'] == null ? undefined : json['borrowerName'],
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'product': json['product'] == null ? undefined : json['product'],
    };
}

export function QuoteTabDtoToJSON(json: any): QuoteTabDto {
    return QuoteTabDtoToJSONTyped(json, false);
}

export function QuoteTabDtoToJSONTyped(value?: QuoteTabDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'borrowerName': value['borrowerName'],
        'clientPrice': value['clientPrice'],
        'product': value['product'],
    };
}

